import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">观影优势</h2>
          <p className="text-foreground-600">为什么超过百万用户选择七七影院</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuresData.map((feat, idx) => (
            <div
              key={feat.title}
              className="group relative bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60 text-center hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100/80 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}